import AlertsWindow from './AlertsWindow';

export default AlertsWindow;
